import { modulesConfig, serviceTypes } from '../../config';

const moduleId = 'ServiceRequestLightHelpdesk';
const cacheVersion = '0';

const modulePath = serviceTypes[modulesConfig[moduleId].serviceType].path;

const pagePaths = {
  Module: modulePath,
};
export { moduleId, cacheVersion, pagePaths };
